import React, { useMemo } from 'react';
import styles from './VoucherHeading.module.scss';
import { VOUCHER_STATUSES } from '../../../../../../constants/enums';

const VoucherHeading = ({ statusId, primary, children, ...props }) => {
    const statusName = useMemo(() => {
        let name = '';
        switch (statusId) {
            case VOUCHER_STATUSES.all:
                name = 'all';
                break;
            case VOUCHER_STATUSES.active:
                name = 'active';
                break;
            case VOUCHER_STATUSES.inactive:
                name = 'inactive';
                break;
            default:
                break;
        }
        return name;
    }, [statusId]);

    return (
        <div className={`${styles.headingWrapper} ${styles[statusName]}`}>
            <div className={styles.heading} {...props}>
                <h4 className={styles.primary}>{primary}</h4>
            </div>
            {children}
        </div>
    );
};

export default VoucherHeading;
